import { BackendTemplateController } from "./gencode/BackendTemplateController";
import { FileCodeBackendController } from "./gencode/FileCodeBackendController";
import { TableSequelizeController } from "./gencode/TableSequelizeController";
import { SequelizeController } from "./SequelizeController";

export const  backendTemplateController = new BackendTemplateController("", "backend-template", {});
export const  fileCodeBackendTemplateController = new FileCodeBackendController("", "file-code-backend", {});
export const tableSequelizeController = new TableSequelizeController("", "table-sequelize", {});
export const genCodeController = new SequelizeController();